import React, { useState } from "react";
import ReactModal from "react-modal";
import style from "../SendMerchantLink/SendMerchantLink.module.scss";
import ButtonIcon from "../../../../components/ButtonIcon/ButtonIcon";
import { changeOtpMobileNumber } from "../../../../../api";
import toast from "react-hot-toast";
const phoneRegex = /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const OTP_PHONE_PREFIX = '+1';

function EditMobile({ open, onClose, appData, fetchApplication }) {

  const [otpNumber, setOtpNumber] = useState(appData?.otp_phone_number ? parseInt(appData?.otp_phone_number?.toString()?.substring(2)) : "");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const validatePhoneNumber = (number) => {
    return phoneRegex.test(number);
  };

  const handleChange = (e) => {
    const { value } = e.target;
    setOtpNumber(value);
    if (validatePhoneNumber(value)) {
      setError("");
    } else {
      setError("Invalid phone number");
    }
  };

  const updateOTPPhone = async () => {
    const payload = {
      otp_phone_number: OTP_PHONE_PREFIX + otpNumber,
      editslug: appData?.editslug,
      id: appData?.id
    }
    setIsLoading(true);
    setError("");
    const toastId = toast.loading("Loading...");
    const response = await changeOtpMobileNumber(payload);
    if (response.status) {
      toast.success("OTP mobile updated successfully!", { id: toastId });
      fetchApplication();
      onClose();
    } else {
      toast.error("Something went wrong!", { id: toastId });
      setIsLoading(false);
      setError('Something went wrong!');
    }
  }

  return (
    <ReactModal isOpen={open} className={style.react_modal}>
      <div className={style.header}>
        <ButtonIcon onClick={onClose}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.28033 3.21967C3.98744 2.92678 3.51256 2.92678 3.21967 3.21967C2.92678 3.51256 2.92678 3.98744 3.21967 4.28033L6.93934 8L3.21967 11.7197C2.92678 12.0126 2.92678 12.4874 3.21967 12.7803C3.51256 13.0732 3.98744 13.0732 4.28033 12.7803L8 9.06066L11.7197 12.7803C12.0126 13.0732 12.4874 13.0732 12.7803 12.7803C13.0732 12.4874 13.0732 12.0126 12.7803 11.7197L9.06066 8L12.7803 4.28033C13.0732 3.98744 13.0732 3.51256 12.7803 3.21967C12.4874 2.92678 12.0126 2.92678 11.7197 3.21967L8 6.93934L4.28033 3.21967Z"
              fill="#737278"
            />
          </svg>
        </ButtonIcon>
      </div>

      <div className={style.body}>
        <h6>Edit OTP Mobile</h6>

        <div className={style.form_group}>
          <label htmlFor="otp_phone_number">OTP Mobile Number</label>
          <input
            type="text"
            name="otp_phone_number"
            id="otp_phone_number"
            value={otpNumber}
            onChange={handleChange}
            className={style.input_select}
          />
          {error && <span className={style.error}>{error}</span>}
        </div>
      </div>

      <div className={style.footer_modal}>
        <div className={style.button_group}>
          <ButtonIcon textColor="#254FE2" onClick={onClose}>
            Cancel
          </ButtonIcon>
          <ButtonIcon
            bgColor={"#4C70EF"}
            textColor="#FFF"
            isLoading={isLoading}
            disabled={error}
            onClick={() => updateOTPPhone()}
          >
            Send
          </ButtonIcon>
        </div>
      </div>
    </ReactModal>
  );
}

export default EditMobile;
